import Tooolabs_Component from './component';
import Tooolabs_Prototype from './prototype';

export const Component = Tooolabs_Component;
export const Prototype = Tooolabs_Prototype;

export default {
    Component,
    Prototype
}